export default __webpack_public_path__ + "static/media/avitar-peretz.f8282f33.png";